import {Flex, HStack, Icon, Text} from "@chakra-ui/react";
import {Select} from "chakra-react-select";
import React, {useEffect, useState} from "react";

// @ts-ignore
export default function SettingItem({icon, label, options, value, update}) {


    const [selectValue, setSelectValue] = useState(value);


    useEffect(() => {
        setSelectValue(value);
    }, [value]);


    const changeValue = (value: any) => {
        setSelectValue(value)
        if (value && value.value) {
            update(value.value)
        }

    }

    return (
        <Flex align="center" justify="space-around">
            <HStack w="100%">
                <Icon as={icon}/>
                <Text fontWeight="bold">{label}</Text>
            </HStack>
            <Select
                options={options}
                size="sm"
                value={selectValue}
                onChange={changeValue}
            />
        </Flex>
    );
}